import axios from "@/store/axios";
import {V1API} from "@/http/APIPath";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";
import dataMagic, {decode, encode} from "@/store/dataMagic"
import ToastificationContent from "@core/components/toastification/ToastificationContent";

const keyList = {
    campaignUpdate : 'CAMPAIGN_UPDATE',
    campaignDelete : 'CAMPAIGN_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,
    state : {
        campaign: [],
        campaignLoading: false,
        campaignError: false,
        submitLoading: false,
        submitError: false,
        submitSuccess: false,


        ...store
    },
    mutations : {
        ...mutations,
        SET_CAMPAIGN (state, campaign) {
            state.campaign = campaign;
        },

        CAMPAIGN_LOADING (state, loading) {
            state.campaignLoading = loading;
        },
        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        }
    },
    actions: {

        async updateCampaign({commit, state, dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);
            try{
                let data = new FormData();

                let payloadData=buildFormData(data,payload.data);
                // console.log(...payloadData)
                let headerConfig=  {
                    "Content-Type": "multipart/form-data"
                }

                let response = await axios.patch(V1API.campaign_update+payload.slug,payloadData,headerConfig).then(result=>{
                    let data=decode(result)
                    console.log(result.status)
                    return data.status

                });

                commit('SUBMIT_SUCCESS', true);
                // dispatch ('fetchCampaignByID',payload.slug)
                return response
            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },

        async updateCampaignWeight({commit, state, dispatch}, payload) {
            let response = '';
            await performNetworkCall(
                commit,
                keyList.projectDelete,
                async () => {

                    response = await axios.post(V1API.weight_updater+ payload.weight_slug, payload.body).then(result => {
                        let data = decode(result.data)
                        return data.message

                    });
                    dispatch('fetchCampaign');
                }
            )

            return response
        },

        async deleteCampaign({commit, state, dispatch}, payload) {
            let response='';
            await performNetworkCall(
                commit,
                keyList.campaignDelete,
                async () => {

                    response = await axios.delete(V1API.campaign_get+'/'+payload).then(result=>{
                        let data=decode(result.data)
                        return data.message

                    });
                    dispatch('fetchCampaign');
                }
            )

            return response
        },

        async fetchCampaign ({ commit },payload) {
            commit('CAMPAIGN_LOADING', true);
            commit('CAMPAIGN_ERROR', false);
            try{

                let result = await axios.get(V1API.campaign_get);
                let response=decode(result.data)

                commit('SET_CAMPAIGN', response);

            }catch(error) {

                commit('CAMPAIGN_ERROR', true);

            }
            commit('CAMPAIGN_LOADING', false);
        },
        async fetchCampaignByID ({ commit },payload) {
            commit('CAMPAIGN_LOADING', true);
            commit('CAMPAIGN_ERROR', false);
            try{

                let result = await axios.get(V1API.campaign_by_id+payload);
                let response=decode(result.data)

                commit('SET_CAMPAIGN', response);

            }catch(error) {

                commit('CAMPAIGN_ERROR', true);

            }
            commit('CAMPAIGN_LOADING', false);
        },
        async fetchCampaignByConcern ({ commit },payload) {
            commit('CAMPAIGN_LOADING', true);
            commit('CAMPAIGN_ERROR', false);
            try{

                let result = await axios.get(V1API.campaign_get_by_concern+'/'+payload.id);
                let response=decode(result.data)

                commit('SET_CAMPAIGN', response);

            }catch(error) {

                commit('CAMPAIGN_ERROR', true);

            }
            commit('CAMPAIGN_LOADING', false);
        },
        async addCampaign({commit,dispatch}, payload) {
            commit('SUBMIT_LOADING', true);
            commit('SUBMIT_ERROR', false);
            try{
                let data = new FormData();

                let payloadData=buildFormData(data,payload);
                let headerConfig=  {
                    "Content-Type": "multipart/form-data"
                }
                let response = await axios.post(V1API.campaign_add,payloadData,headerConfig).then(result=>{
                    let data=decode(result)
                    return data

                });

                commit('SUBMIT_SUCCESS', true);
                // dispatch ('fetchCampaign')
                return response
            }catch (e) {
                commit('SUBMIT_ERROR', true);
            }finally {
                commit('SUBMIT_LOADING', false);
            }
        },

    },
    getters: {}
}
